export const navLinks = [
  { label: '首页', href: '#hero' },
  { label: '特色优势', href: '#features' },
  { label: '热门吃瓜榜', href: '#ranking' },
  { label: '焦点专题', href: '#carousel' },
  { label: '热门话题', href: '#topics' },
];

export const heroData = {
  tag: '实时更新 · 高清流畅 · 全网聚合',
  h1: '吃瓜在线 — 一站式吃瓜视频聚合平台',
  slogan: '51吃瓜 · 91吃瓜 · 全网热瓜一网打尽',
  intro: '吃瓜在线专注聚合51吃瓜在线观看与91吃瓜在线观看等全网优质视频资源，覆盖娱乐八卦、热点事件、综艺名场面等热门内容。平台每日持续更新最新吃瓜视频，支持吃瓜在线免费播放与吃瓜在线高清观看，无需跳转即可畅享流畅播放体验。无论是最新爆料还是经典回顾，吃瓜在线为你提供一站式吃瓜在线看视频服务。',
  stats: [
    { value: '200+', label: '每日更新视频' },
    { value: '1080P', label: '高清画质保障' },
    { value: '7×24', label: '全天候内容更新' },
  ],
  ctaPrimary: { label: '立即看瓜', href: '#media' },
  ctaSecondary: { label: '热门吃瓜榜', href: '#ranking' },
};

export const mediaItems = [
  {
    id: 1,
    title: '某顶流艺人深夜密会神秘女子，全程高清实拍画面曝光',
    duration: '15:32',
    views: '128.6万',
    tag: '娱乐八卦',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20entertainment%20news%20studio%20set%20with%20dramatic%20lighting%2C%20red%20velvet%20curtains%2C%20spotlight%20effect%2C%20cinematic%20atmosphere%2C%20warm%20golden%20and%20burgundy%20tones%2C%20editorial%20photography%20style%2C%20mysterious%20mood%2C%20film%20noir%20aesthetic&width=800&height=450&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '热门综艺录制现场突发状况，导师当场翻脸气氛紧张',
    duration: '22:08',
    views: '96.3万',
    tag: '综艺名场面',
    image: 'https://readdy.ai/api/search-image?query=TV%20variety%20show%20stage%20with%20colorful%20lighting%20and%20judges%20panel%2C%20dramatic%20atmosphere%2C%20red%20and%20gold%20stage%20design%2C%20audience%20silhouettes%2C%20cinematic%20photography%2C%20warm%20tone%20lighting%2C%20professional%20broadcast%20studio&width=800&height=450&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '最新独家爆料：知名导演新片选角内幕，多位演员竞争激烈',
    duration: '18:45',
    views: '203.1万',
    tag: '独家爆料',
    image: 'https://readdy.ai/api/search-image?query=film%20director%20casting%20scene%20with%20camera%20equipment%20and%20spotlight%2C%20behind%20the%20scenes%20movie%20set%2C%20warm%20cinematic%20lighting%2C%20professional%20film%20production%20atmosphere%2C%20red%20and%20cream%20color%20palette&width=800&height=450&seq=media-03&orientation=landscape',
  },
];

export const rankingItems = [
  { rank: 1, title: '某女星离婚内幕遭知情人曝光，细节令人唏嘘', hot: '986.5万', trend: 'up' },
  { rank: 2, title: '顶流小生夜店狂欢被拍，形象大跌粉丝集体脱粉', hot: '874.2万', trend: 'up' },
  { rank: 3, title: '综艺节目录制现场意外中断，全场哗然一片', hot: '762.8万', trend: 'up' },
  { rank: 4, title: '某国际品牌代言人突然宣布解约，背后原因成谜', hot: '651.3万', trend: 'up' },
  { rank: 5, title: '知名网红直播翻车名场面，场面一度十分尴尬', hot: '543.7万', trend: 'down' },
  { rank: 6, title: '热播剧男主片场被指耍大牌，同组演员发声回应', hot: '489.1万', trend: 'up' },
  { rank: 7, title: '某歌手新歌深陷抄袭风波，原作者正式发声维权', hot: '432.6万', trend: 'down' },
];

export const aboutData = {
  title: '关于吃瓜在线',
  content: '吃瓜在线是一个专注于娱乐八卦与热点事件视频聚合的在线观看平台。我们聚合了51吃瓜与91吃瓜等全网优质高清视频资源，致力于为用户提供便捷、流畅的吃瓜在线观看体验。平台内容涵盖娱乐圈动态、综艺名场面、网红热点、影视幕后等多个领域，每日更新海量最新视频。吃瓜在线支持吃瓜在线免费播放、吃瓜在线高清观看及吃瓜在线最新视频在线看，让每一位用户都能轻松获取最新最热的吃瓜内容。',
  features: ['全网资源聚合', '高清流畅播放', '每日实时更新', '多端兼容观看'],
};

export const updateItems = [
  { date: '2026-07-30', text: '平台新增「焦点专题」板块，精选每周最热吃瓜事件深度汇总' },
  { date: '2026-07-28', text: '吃瓜在线视频库突破10万条，涵盖51吃瓜与91吃瓜全量资源' },
  { date: '2026-07-25', text: '播放器全面升级，支持1080P超清画质与智能缓冲技术' },
  { date: '2026-07-22', text: '移动端适配优化完成，手机观看吃瓜在线视频更流畅' },
  { date: '2026-07-19', text: '新增「热门吃瓜榜」功能，实时展示全网最热吃瓜话题排名' },
  { date: '2026-07-15', text: '内容审核机制升级，确保所有视频资源安全合规可观看' },
  { date: '2026-07-10', text: '吃瓜在线日活跃用户突破百万，感谢每一位吃瓜爱好者的支持' },
  { date: '2026-07-05', text: '平台正式上线「话题广场」功能，一键浏览全网热门吃瓜话题' },
];

export const topicItems = [
  { id: 1, name: '娱乐圈爆料', count: '2.3万', hot: true },
  { id: 2, name: '综艺名场面', count: '1.8万', hot: true },
  { id: 3, name: '网红八卦', count: '1.5万', hot: true },
  { id: 4, name: '影视幕后', count: '1.2万', hot: false },
  { id: 5, name: '明星动态', count: '1.1万', hot: true },
  { id: 6, name: '吃瓜前线', count: '9800', hot: false },
  { id: 7, name: '热门剧集', count: '8600', hot: false },
  { id: 8, name: '时尚八卦', count: '7200', hot: false },
  { id: 9, name: '音乐圈瓜', count: '6500', hot: false },
  { id: 10, name: '直播翻车', count: '5800', hot: false },
  { id: 11, name: '体育娱乐', count: '4200', hot: false },
];

export const faqItems = [
  {
    q: '吃瓜在线是什么平台？',
    a: '吃瓜在线是一个聚合51吃瓜在线观看与91吃瓜在线观看等全网高清视频资源的一站式观看平台。我们汇集了娱乐八卦、热点事件、综艺名场面等各类吃瓜视频，支持吃瓜在线免费播放和高清观看，让用户无需跳转即可畅享流畅的观看体验。',
  },
  {
    q: '吃瓜在线的视频资源从哪里来？',
    a: '吃瓜在线的视频资源主要聚合自51吃瓜与91吃瓜等主流内容平台，同时覆盖多个视频源站点。我们通过智能聚合技术实时同步最新内容，确保用户可以第一时间观看到吃瓜在线最新视频，满足吃瓜在线看视频的多样化需求。',
  },
  {
    q: '吃瓜在线需要付费吗？',
    a: '吃瓜在线目前所有视频均支持免费播放。用户无需注册或付费即可在线观看全部内容。我们致力于为用户提供优质的吃瓜在线免费播放服务，让每一位吃瓜爱好者都能自由畅享高清视频内容。',
  },
  {
    q: '吃瓜在线的视频画质如何？',
    a: '吃瓜在线支持最高1080P高清画质播放。平台采用先进的视频编码与智能缓冲技术，即使在移动网络环境下也能流畅观看吃瓜在线高清内容。用户可根据自身网络状况灵活选择画质档位。',
  },
  {
    q: '如何在手机上观看吃瓜在线视频？',
    a: '吃瓜在线已全面适配移动端浏览。用户可直接通过手机浏览器访问吃瓜在线，无需下载任何APP即可享受流畅的手机观看体验。页面针对小屏幕进行了专门优化，操作便捷。',
  },
];

export const indexItems = [
  { id: 1, title: '娱乐圈深度爆料合集', desc: '最全明星八卦内幕一网打尽', count: '568' },
  { id: 2, title: '综艺名场面盘点', desc: '那些令人捧腹或震惊的综艺瞬间', count: '432' },
  { id: 3, title: '网红翻车实录', desc: '直播翻车、人设崩塌全记录', count: '387' },
  { id: 4, title: '影视圈内幕揭秘', desc: '片场趣事、选角内幕独家呈现', count: '315' },
  { id: 5, title: '每周吃瓜速递', desc: '一周热点瓜情汇总，不错过任何精彩', count: '289' },
  { id: 6, title: '经典吃瓜回顾', desc: '那些年轰动全网的大瓜重温', count: '256' },
  { id: 7, title: '吃瓜冷知识', desc: '你不知道的娱乐圈奇闻趣事', count: '198' },
];

export const appData = {
  title: '随时随地 · 畅快吃瓜',
  subtitle: '手机浏览器直接访问，无需下载APP',
  desc: '吃瓜在线全面适配移动端，在手机浏览器中即可享受与电脑端一致的高清流畅观看体验。无论你在地铁上、咖啡厅还是家中，打开浏览器就能看51吃瓜与91吃瓜的精彩内容。',
  features: ['无需安装', '即开即看', '流量优化', '画质自适应'],
  image: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20entertainment%20video%20streaming%20interface%20with%20warm%20red%20and%20gold%20theme%2C%20modern%20mobile%20UI%20design%2C%20clean%20minimal%20layout%2C%20cinematic%20content%20preview%20screen%2C%20soft%20warm%20lighting%20on%20phone%20screen&width=600&height=800&seq=app-mobile&orientation=portrait',
};

export const cardItems = [
  {
    id: 1,
    title: '某知名女星疑似恋情曝光，与神秘男子同游被拍',
    desc: '近日有网友拍到某一线女星与一名神秘男子在某度假胜地同游，举止亲密引发热议。',
    tag: '明星恋情',
    date: '2026-07-29',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20sunset%20beach%20resort%20scene%20with%20palm%20trees%20silhouette%2C%20warm%20golden%20hour%20lighting%2C%20tropical%20vacation%20atmosphere%2C%20luxury%20resort%20aesthetic%2C%20cinematic%20mood%2C%20soft%20pink%20and%20orange%20sky&width=800&height=500&seq=card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '热门综艺收视率创新高，节目组宣布续订下一季',
    desc: '某热门综艺节目本季收视率屡创新高，节目组正式宣布将续订下一季，粉丝期待值拉满。',
    tag: '综艺动态',
    date: '2026-07-28',
    image: 'https://readdy.ai/api/search-image?query=Television%20studio%20stage%20with%20bright%20colorful%20lighting%20and%20large%20LED%20screens%2C%20empty%20audience%20seats%2C%20professional%20broadcast%20equipment%2C%20warm%20stage%20illumination%2C%20golden%20and%20red%20color%20palette&width=800&height=500&seq=card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '某品牌官宣新代言人，粉丝直呼意想不到的组合',
    desc: '国际知名品牌突然官宣全新代言人，这一跨界组合让网友直呼惊喜，话题迅速登上热搜。',
    tag: '品牌代言',
    date: '2026-07-27',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20brand%20fashion%20photography%20studio%20with%20elegant%20spotlight%20and%20red%20velvet%20backdrop%2C%20high%20end%20commercial%20set%2C%20warm%20golden%20accent%20lighting%2C%20sophisticated%20atmosphere&width=800&height=500&seq=card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '某导演新片片场路透流出，豪华阵容引发期待',
    desc: '备受关注的某大导新片片场路透近日流出，演员阵容堪称豪华，影迷纷纷表示期待值爆表。',
    tag: '影视动态',
    date: '2026-07-26',
    image: 'https://readdy.ai/api/search-image?query=Movie%20film%20set%20with%20professional%20camera%20equipment%20and%20crew%20working%2C%20behind%20the%20scenes%20cinematic%20atmosphere%2C%20warm%20tungsten%20lighting%2C%20director%20chair%20and%20clapperboard&width=800&height=500&seq=card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '某歌手演唱会突发状况，机智救场获全场掌声',
    desc: '某知名歌手在演唱会上遭遇设备故障，但凭借丰富的舞台经验机智化解，现场观众报以热烈掌声。',
    tag: '音乐现场',
    date: '2026-07-25',
    image: 'https://readdy.ai/api/search-image?query=Concert%20stage%20with%20dramatic%20spotlight%20and%20smoke%20effects%2C%20empty%20stage%20with%20microphone%20stand%2C%20purple%20and%20gold%20atmospheric%20lighting%2C%20live%20music%20performance%20vibe&width=800&height=500&seq=card-05&orientation=landscape',
  },
];

export const featureItems = [
  {
    id: 1,
    icon: 'ri-stack-line',
    title: '海量资源聚合',
    desc: '覆盖51吃瓜在线观看与91吃瓜在线观看等全网视频资源，每日自动同步更新，确保内容最全最新。',
  },
  {
    id: 2,
    icon: 'ri-4k-line',
    title: '高清画质保障',
    desc: '全线支持1080P超清播放，智能自适应码率技术，不同网络环境下均可流畅享受吃瓜在线高清观看。',
  },
  {
    id: 3,
    icon: 'ri-timer-flash-line',
    title: '全天候实时更新',
    desc: '7×24小时不间断内容更新机制，第一时间推送吃瓜在线最新视频，绝不错过任何热点。',
  },
  {
    id: 4,
    icon: 'ri-smartphone-line',
    title: '全端流畅体验',
    desc: '全面适配电脑、手机、平板等多终端，即开即看无需下载，随时随地畅享吃瓜在线免费播放。',
  },
];

export const commentItems = [
  {
    id: 1,
    name: '吃瓜群众A',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20geometric%20avatar%20with%20warm%20peach%20tone%2C%20minimalist%20circle%20design%2C%20clean%20flat%20illustration%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    text: '这个平台太方便了！之前在好几个网站之间跳来跳去找视频，现在一个网站就能看51吃瓜和91吃瓜的全部内容，画质也很清晰，必须给好评！',
    date: '2026-07-29',
    likes: 562,
  },
  {
    id: 2,
    name: '八卦研究员',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20geometric%20avatar%20with%20warm%20coral%20tone%2C%20minimalist%20hexagon%20design%2C%20clean%20flat%20illustration%20style&width=80&height=80&seq=avatar-02&orientation=squarish',
    text: '吃瓜在线真的很好用，更新的速度很快，基本上热点一出就能在这里看到。视频加载也很流畅，不卡顿。已经在推荐给身边的朋友了。',
    date: '2026-07-28',
    likes: 438,
  },
  {
    id: 3,
    name: '追剧小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20geometric%20avatar%20with%20warm%20amber%20tone%2C%20minimalist%20diamond%20design%2C%20clean%20flat%20illustration%20style&width=80&height=80&seq=avatar-03&orientation=squarish',
    text: '手机上看也很方便，不用下载APP省了不少内存。画质高清播放流畅，通勤路上看吃瓜视频成了每天的固定节目哈哈。',
    date: '2026-07-27',
    likes: 387,
  },
  {
    id: 4,
    name: '资深吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20geometric%20avatar%20with%20warm%20rose%20tone%2C%20minimalist%20square%20design%2C%20clean%20flat%20illustration%20style&width=80&height=80&seq=avatar-04&orientation=squarish',
    text: '作为一个资深吃瓜爱好者，吃过无数瓜，这个平台的资源是真的全。51吃瓜和91吃瓜的内容都有，而且分类清晰，想找什么类型的瓜都很方便。',
    date: '2026-07-26',
    likes: 521,
  },
];

export const carouselItems = [
  {
    id: 1,
    title: '七月娱乐圈大事件盘点',
    desc: '本月娱乐圈风波不断，从顶流恋情曝光到综艺录制意外，带你一次性回顾七月最火爆的吃瓜名场面。',
    tag: '月度盘点',
    count: '32篇',
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20news%20collage%20concept%20with%20dramatic%20red%20velvet%20curtain%20and%20golden%20spotlight%2C%20stage%20atmosphere%2C%20cinematic%20composition%2C%20warm%20theatrical%20lighting%2C%20editorial%20magazine%20cover%20style&width=1000&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '那些年我们一起追的大瓜',
    desc: '从轰动全网的离婚事件到令人震惊的税务风波，回顾近年来最令人难忘的经典吃瓜事件，每一件都记忆犹新。',
    tag: '经典回顾',
    count: '25篇',
    image: 'https://readdy.ai/api/search-image?query=Nostalgic%20film%20reel%20and%20vintage%20newspaper%20concept%2C%20warm%20sepia%20tone%20with%20golden%20lighting%2C%20memory%20lane%20theme%2C%20cinematic%20retro%20atmosphere%2C%20old%20Hollywood%20glamour%20style&width=1000&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '综艺名场面大赏',
    desc: '各大综艺节目中那些让人捧腹大笑或目瞪口呆的高能名场面，你错过了几个？快来补课！',
    tag: '综艺集锦',
    count: '28篇',
    image: 'https://readdy.ai/api/search-image?query=TV%20show%20highlight%20reel%20concept%20with%20colorful%20burst%20effects%20and%20confetti%2C%20entertainment%20awards%20show%20vibe%2C%20golden%20and%20red%20party%20atmosphere%2C%20celebratory%20stage%20lighting&width=1000&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '网红圈风云录',
    desc: '直播带货翻车、人设崩塌、粉丝互撕……网红圈的精彩程度一点不输娱乐圈，最新网红八卦全收录。',
    tag: '网红专题',
    count: '21篇',
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20live%20streaming%20concept%20with%20smartphone%20ring%20light%20setup%2C%20modern%20influencer%20studio%20background%2C%20warm%20neon%20accent%20lighting%2C%20digital%20content%20creation%20atmosphere&width=1000&height=600&seq=carousel-04&orientation=landscape',
  },
  {
    id: 5,
    title: '音乐圈年度吃瓜特辑',
    desc: '从新歌抄袭争议到演唱会意外事件，音乐圈的瓜同样精彩纷呈，为你整理年度最热音乐圈八卦。',
    tag: '音乐专题',
    count: '19篇',
    image: 'https://readdy.ai/api/search-image?query=Music%20recording%20studio%20with%20vintage%20instruments%20and%20warm%20ambient%20lighting%2C%20gramophone%20and%20vinyl%20records%2C%20golden%20sunset%20through%20window%2C%20nostalgic%20music%20atmosphere%2C%20warm%20analog%20vibe&width=1000&height=600&seq=carousel-05&orientation=landscape',
  },
];

export const contactData = {
  title: '联系我们',
  desc: '如果你有任何关于吃瓜在线的建议、意见或想要投稿合作，欢迎通过以下方式与我们取得联系。',
  email: 'contact@chigua-online.com',
  tips: '工作时间：周一至周五 9:00-18:00，我们会在收到信息后尽快回复。',
};

export const footerData = {
  desc: '吃瓜在线 — 聚合51吃瓜在线观看与91吃瓜在线观看等全网高清吃瓜视频资源，致力于为用户提供便捷的吃瓜在线免费播放、吃瓜在线高清观看及吃瓜在线最新视频在线看服务。每日更新海量内容，让你不错过任何精彩瓜情。',
  sections: [
    {
      title: '快速导航',
      links: [
        { label: '精选视频', href: '#media' },
        { label: '热门吃瓜榜', href: '#ranking' },
        { label: '焦点专题', href: '#carousel' },
        { label: '热门话题', href: '#topics' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '平台介绍', href: '#about' },
        { label: '常见问题', href: '#faq' },
        { label: '最新动态', href: '#updates' },
        { label: '联系我们', href: '#contact' },
      ],
    },
  ],
};